import React from "react";
import {useTranslation} from "react-i18next";
import MDInput from "../../../../materialDashboard/components/MDInput";


const SearchField = ({onChange=f=>f}) => {
    const {t} = useTranslation(["components"]);

    // Search input state handle
    const handleSearchChange = debounce((value) => {
        onChange("search", value);
    }, 100);

    return <MDInput placeholder={t("dataTable.search")}
                    size="small"
                    fullWidth
                    onChange={({currentTarget}) => {
                        handleSearchChange(currentTarget.value);
                    }}
                    sx={{p: 0}}
    />
}

function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}


export default SearchField;